import gql from 'graphql-tag';

export const CREATE_BILLING_SESSION = gql`
  query CreateBillingSession {
    createBillingSession {
      id
      created
      livemode
      url
    }
  }
`;
